import { createContext, useContext } from 'react';
import { AuthContextType } from '@/utils/interfaces/auth/auth.interface';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
